import { httpClient } from "../common/httpclient";
import DialogForm from "./dialog/DialogForm";
import { TextField, RadioGroup, FormControlLabel, Radio, FormControl, FormLabel } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from "react";
import { standaloneFieldSx } from "../common/fieldStyles";

export default function NewCustomer({ open, setOpen, onSuccess }) {
    const theme = useTheme();
    const [customerType, setCustomerType] = useState('pf');
    const [errorName, setErrorName] = useState(false);
    const [errorLastname, setErrorLastname] = useState(false);
    const [errorLegalName, setErrorLegalName] = useState(false);
    const [errorTradeName, setErrorTradeName] = useState(false);

    // Reset form when dialog opens/closes
    useEffect(() => {
        if (open) {
            setCustomerType('pf');
            setErrorName(false);
            setErrorLastname(false);
            setErrorLegalName(false);
            setErrorTradeName(false);
        }
    }, [open]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());

        const cellphone = formJson.cellphone;
        var valid = true;

        if (customerType === 'pf') {
            const name = formJson.name;
            const lastname = formJson.lastname;
            
            if (!name) {
                setErrorName(true);
                valid = false;
            }
            if (!lastname) {
                setErrorLastname(true);
                valid = false;
            }

            if (!valid) {
                return;
            }

            const newCustomer = {
                firstName: name,
                lastName: lastname,
                cellPhone: cellphone
            };

            try {
                const response = await httpClient.post('/customers/person', newCustomer);
                const res = response.data || {};
                const customerId =
                    res.id ||
                    res.ID ||
                    res.Id ||
                    res.customer_id ||
                    res.customerId ||
                    res.CustomerId;
                const createdCustomer = {
                    id: customerId,
                    ID: customerId,
                    Id: customerId,
                    Name: `${name} ${lastname}`,
                    firstName: name,
                    lastName: lastname,
                    cellPhone: cellphone
                };
                onSuccess(createdCustomer);
                setOpen(false);
            } catch (error) {
                console.error('Erro ao criar cliente PF:', error);
            }
        } else {
            const legalName = formJson.legalName;
            const tradeName = formJson.tradeName;
            
            if (!legalName) {
                setErrorLegalName(true);
                valid = false;
            }
            if (!tradeName) {
                setErrorTradeName(true);
                valid = false;
            }

            if (!valid) {
                return;
            }

            const newCustomer = {
                legalName: legalName,
                tradeName: tradeName,
                cellPhone: cellphone
            };

            try {
                const response = await httpClient.post('/customers/enterprise', newCustomer);
                const res = response.data || {};
                const customerId =
                    res.id ||
                    res.ID ||
                    res.Id ||
                    res.customer_id ||
                    res.customerId ||
                    res.CustomerId;
                const createdCustomer = {
                    id: customerId,
                    ID: customerId,
                    Id: customerId,
                    Name: tradeName || legalName,
                    tradeName: tradeName,
                    legalName: legalName,
                    cellPhone: cellphone
                };
                onSuccess(createdCustomer);
                setOpen(false);
            } catch (error) {
                console.error('Erro ao criar cliente PJ:', error);
            }
        }
    };

    return (
        <DialogForm
            open={open}
            onClose={() => setOpen(false)}
            title="Novo Cliente"
            content="Preencha os campos abaixo para criar um novo cliente."
            onSubmit={handleSubmit}
            iconType="info"
        >
            <FormControl component="fieldset" sx={{ mb: 2, width: '100%' }}>
                <FormLabel component="legend" sx={{ mb: 1, color: theme.palette.text.secondary }}>
                    Tipo de Cliente
                </FormLabel>
                <RadioGroup
                    row
                    value={customerType}
                    onChange={(e) => setCustomerType(e.target.value)}
                    sx={{ 
                        '& .MuiFormControlLabel-label': {
                            color: theme.palette.text.primary
                        }
                    }}
                >
                    <FormControlLabel value="pf" control={<Radio />} label="Pessoa Física (PF)" />
                    <FormControlLabel value="pj" control={<Radio />} label="Pessoa Jurídica (PJ)" />
                </RadioGroup>
            </FormControl>

            {customerType === 'pf' ? (
                <>
                    <TextField
                        inputRef={(input) => {
                            if (input && open) {
                                input.focus();
                            }
                        }}
                        id="name"
                        name="name"
                        label="Nome"
                        type="text"
                        fullWidth
                        variant="outlined"
                sx={standaloneFieldSx}
                        onChange={(e) => setErrorName(false)}
                        error={errorName}
                        helperText={errorName ? 'Campo obrigatório' : ''}
                    />

                    <TextField
                        id="lastname"
                        name="lastname"
                        label="Sobrenome"
                        type="text"
                        fullWidth
                        variant="outlined"
                        sx={standaloneFieldSx}
                        onChange={(e) => setErrorLastname(false)}
                        error={errorLastname}
                        helperText={errorLastname ? 'Campo obrigatório' : ''}
                    />
                </>
            ) : (
                <>
                    <TextField
                        inputRef={(input) => {
                            if (input && open) {
                                input.focus();
                            }
                        }}
                        id="legalName"
                        name="legalName"
                        label="Razão Social"
                        type="text"
                        fullWidth
                        variant="outlined"
                        sx={standaloneFieldSx}
                        onChange={(e) => setErrorLegalName(false)}
                        error={errorLegalName}
                        helperText={errorLegalName ? 'Campo obrigatório' : ''}
                    />

                    <TextField
                        id="tradeName"
                        name="tradeName"
                        label="Nome Fantasia"
                        type="text"
                        fullWidth
                        variant="outlined"
                        sx={standaloneFieldSx}
                        onChange={(e) => setErrorTradeName(false)}
                        error={errorTradeName}
                        helperText={errorTradeName ? 'Campo obrigatório' : ''}
                    />
                </>
            )}

            <TextField
                id="phone"
                name="cellphone"
                label="Celular"
                type="tel"
                fullWidth
                variant="outlined"
                        sx={standaloneFieldSx}
                inputProps={{
                    maxLength: 15,
                    pattern: "\\([0-9]{2}\\) [0-9]{5}-[0-9]{4}",
                    placeholder: "(19) 99999-9999"
                }}
                onChange={(e) => {
                    let digits = e.target.value.replace(/\D/g, '').slice(0, 11);
                    let formatted = '';
                    if (digits.length > 0) {
                        formatted = `(${digits.slice(0, 2)}`;
                        if (digits.length > 2) {
                            formatted += `) ${digits.slice(2, 7)}`;
                            if (digits.length > 7) {
                                formatted += `-${digits.slice(7, 11)}`;
                            }
                        }
                    }
                    e.target.value = formatted;
                }}
            />
        </DialogForm>
    );
}